import { render, staticRenderFns } from "./diklat_fungsional.vue?vue&type=template&id=b3478108&"
import script from "./diklat_fungsional.vue?vue&type=script&lang=js&"
export * from "./diklat_fungsional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports